import { useTranslation } from 'react-i18next';
import { useGetPersonalGuaranteeList } from '@/query/queries/loan/useGetPersonalGuaranteeList';
import { LoanCard } from '../LoanCard';
import s from '../../index.module.scss';

export const ReleasedList = () => {
  const { t } = useTranslation('founder-pricing');
  const { data } = useGetPersonalGuaranteeList({ status: 'released' });

  return (
    <div className={s.wrapper}>
      <div className="f-42 f-500">{t('fpg_page.released_title')}</div>
      {data?.list.map(loan => (
        <LoanCard loan={loan} key={loan.id} />
      ))}
      {!data?.list.length && <div className="f-body-accent">No data</div>}
    </div>
  );
};
